import { BrowserModule }                       from '@angular/platform-browser';
import { NgModule, NgZone }                    from '@angular/core';
import { FormsModule, ReactiveFormsModule  }   from '@angular/forms';
import { BrowserAnimationsModule }             from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import tether                                  from 'tether';
import { SimpleNotificationsModule }           from 'angular2-notifications';
 
import { configuration }                       from '../config/config'; 
import { AppComponent }                        from './app.component';
import { CoreModule }                          from '../../../esscalo_funcionalidad/src/app/app.module';
import { LoginComponent }                      from '../../../esscalo_funcionalidad/src/login/login.component';
import { EsscaloComponent }                    from '../../../esscalo_funcionalidad/src/components/escalo/escalo.component';
import { EsscaloAdminComponent }               from '../../../esscalo_funcionalidad/src/components/esscaloAdmin/esscalo-admin.component';

import { GroupComponent }                      from '../../../esscalo_funcionalidad/src/components/group/group.component';

import { OrderModule } from 'ngx-order-pipe';

// import { DlDateTimePickerDateModule } from 'angular-bootstrap-datetimepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DatepickerModule, BsDatepickerModule }from 'ngx-bootstrap/datepicker';
import { TypeaheadModule }                     from 'ngx-bootstrap/typeahead'
// import { NotificationsService } from 'angular2-notifications';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
// import { saveAs } from 'file-saver';
// import { SweetAlertService } from 'ngx-sweetalert2';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    EsscaloComponent,
    GroupComponent,
    EsscaloAdminComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    // saveAs,
    SimpleNotificationsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    SweetAlert2Module.forRoot(),
    OrderModule,
    // SweetAlertService
    // DlDateTimePickerDateModule
    BsDropdownModule.forRoot(),
  ],
  exports: [],
  providers: [configuration],
  bootstrap: [AppComponent]
})
export class AppModule { 

  constructor(private config: configuration, ) {
    sessionStorage.config = JSON.stringify(config);
  }

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts